import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/database';

var firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyARdrwMLUcwCdBsZ17urQJXUHuNklFF6Rw",
    authDomain: "contactform-3cf8b.firebaseapp.com",
    databaseURL: "https://contactform-3cf8b-default-rtdb.firebaseio.com",
    projectId: "contactform-3cf8b",
    storageBucket: "contactform-3cf8b.appspot.com",
    messagingSenderId: "731361637266",
    appId: "1:731361637266:web:a845704d46dfa7e95d474b",
    measurementId: "G-4QKPM8M0HY"
});

var db = firebaseApp.firestore();
var realtimeDB = firebaseApp.database();

export { db, realtimeDB };